export default __webpack_public_path__ + "afe3814691f5ee09da1f4b9165ee822c.svg";